define('src/plugins/infinite-collection',[
    'underscore', 'backbone', 'utils',
    // mixins
    'mixins/general/query-params-mixin'
], function(
    // libs
    _, Backbone, U,
    // mixins
    QueryParamsMixin
) {

    var _extend = _.extend,
        _defaults = _.defaults;

    var InfiniteCollection = Backbone.Collection.extend(_.extend({

        state: {
            pageSize: 5, // default value for a page
            total: 0
        },

        queryParams: {
            pageSize: "limit",
            pagesLeft: null,
            total: null,
            sortKey: null,
            order: null,

            skip: function() {
                return this.length;
            }
        },

        /**
         * Default to client side sorting.
         */
        constructor: function(models, options) {
            var proto = InfiniteCollection.prototype;
            this.queryParams = _defaults({}, this.queryParams, proto.queryParams);
            this.state = _defaults({}, this.state, proto.state);

            return InfiniteCollection.__super__.constructor.call(this, models, options);
        },

        getFirstPage: function(opt) {
            opt = _extend({ fetch: true, reset: true }, opt);
            if (opt.reset) this.reset(null, _extend({ silent: true }, opt));
            return this.fetch(opt);
        },

        getAll: function() {
            return this.fetch();
        },

        getNextPage: function(opt) {
            return this.fetch(_extend({
                add: true,
                remove: false,
                merge: true
            }, opt));
        },

        parse: function(resp) {
            if (resp.collection) {
                _extend(this.state, this.parseState(resp));
                return resp.collection;
            }
            return resp;
        },

        parseState: function(resp) {
            var left = resp.total - resp.collection.length - this.length;
            return {
                total: resp.total,
                pagesLeft: Math.ceil(left / this.state.pageSize)
            };
        },

        hasLeft: function() {
            return this.state.total - this.length > 0;
        },

        getTotal: function() {
            return this.hasLeft() ? this.state.total : this.length;
        },

        fetch: function(options) {
            options = options || {};
            var data = options.data || {},
                url = options.url || _.result(this, 'url') || Backbone.Extension.urlError(),
                state = this.state;

            // dedup query params
            var queryStringIndex = url.indexOf('?');
            if (queryStringIndex > -1) {
                data = _extend({}, data, this.queryStringToParams(url.slice(queryStringIndex + 1)));
                url = url.slice(0, queryStringIndex);
            }

            options.url = url;

            // map the query params to the data object used by the underlying ajax lib
            // to construct the query string
            options.data = this.getQueryStringData(data);

            return InfiniteCollection.__super__.fetch.call(this, options);
        },

    }, QueryParamsMixin));

    return InfiniteCollection;
});

